import { render } from "./batchManage.vue?vue&type=template&id=3e9351ef&scoped=true&ts=true"
import script from "./batchManage.vue?vue&type=script&lang=tsx"
export * from "./batchManage.vue?vue&type=script&lang=tsx"

import "./batchManage.vue?vue&type=style&index=0&id=3e9351ef&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e9351ef"]])

export default __exports__